import styled from 'styled-components';

export const ExpandedMobileItems = styled.div`
  display: none;
  @media only screen and (max-width: ${({ mobileSize }) => `${mobileSize}px` || '580px'}) {
    padding: 10px;
    display: ${props => (props.hideMobileTable ? 'none' : 'table')};
    width: 100%;
    ${p => p.expandedMobileItemStyle};
  }
`;
